import { render, staticRenderFns } from "./TheCopyright.vue?vue&type=template&id=dd9ae90a&scoped=true"
import script from "./TheCopyright.vue?vue&type=script&lang=js"
export * from "./TheCopyright.vue?vue&type=script&lang=js"
import style0 from "./TheCopyright.vue?vue&type=style&index=0&id=dd9ae90a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9ae90a",
  null
  
)

export default component.exports